module.exports = __webpack_public_path__ + "static/person.1bbdcd32.svg";